var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_25_1",
    "data-name": "Component 25 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 295.343,
    height: 219.486,
    viewBox: "0 0 295.343 219.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M147.671,305.657C66.259,305.657.234,221.544,0,291.138c0,.009,0,.021,0,.029v.119c0,.026,0,.053,0,.079v.148c0,70.264,66.115,127.224,147.671,127.224s147.672-56.961,147.672-127.224v-.148c0-.026,0-.052,0-.078v-.121c0-.008,0-.018,0-.026,0-.034,0-.071,0-.105v0c-.089-20.282-5.786-27.461-15.844-27.458-24.352.006-74.243,42.085-131.826,42.085",
    transform: "translate(0 -263.57)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1.05,
    x2: 0.001,
    y2: 1.05,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f5fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef9fe"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M165.168,208.31a10.95,10.95,0,0,0-10.912,10.04L142.834,355.287c25.517,18.122,58.218,29.007,93.869,29.007a168.339,168.339,0,0,0,53.593-8.637L275,208.31Z",
    transform: "translate(-142.834 -208.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.365,
    y1: 1.055,
    x2: -0.362,
    y2: 1.055,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7cfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccaed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M183.776,208.31a10.951,10.951,0,0,0-10.913,10.04l-.176,2.109L185.763,235l26.231-26.687Z",
    transform: "translate(-172.687 -208.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.655,
    y1: 6.959,
    x2: -1.645,
    y2: 6.959,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7cfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#96cadf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#7dc2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#6abce7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#5fb9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#5cb8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cb8ea"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M207.4,235V369.329a160.562,160.562,0,0,0,26.231,9.4V208.31Z",
    transform: "translate(-207.4 -208.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2.978,
    y1: 1.09,
    x2: -2.964,
    y2: 1.09,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90c8db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccaed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M283.071,122.114v28.9a3.452,3.452,0,1,0,6.9,0v-28.9a22.415,22.415,0,0,1,22.39-22.39,3.452,3.452,0,1,0,0-6.9,29.326,29.326,0,0,0-29.294,29.294",
    transform: "translate(-283.071 -92.82)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3.256,
    y1: 3.718,
    x2: -3.245,
    y2: 3.718,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M238.58,208.31l-2.162,165.567a167.7,167.7,0,0,0,58.618,10.417c33.675,0,64.713-9.708,89.555-26.057L371.8,218.264a10.95,10.95,0,0,0-10.9-9.954Z",
    transform: "translate(-236.418 -208.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.601,
    y1: 1.055,
    x2: -0.598,
    y2: 1.055,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f5fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6f0fd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M473.87,235.962a6.855,6.855,0,1,0,6.855-6.854,6.855,6.855,0,0,0-6.855,6.854",
    transform: "translate(-473.87 -229.108)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -13.02,
    y1: 12.975,
    x2: -12.992,
    y2: 12.975,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M336.662,235.962a6.855,6.855,0,1,0,6.854-6.854,6.854,6.854,0,0,0-6.854,6.854",
    transform: "translate(-336.662 -229.108)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -9.25,
    y1: 12.975,
    x2: -9.223,
    y2: 12.975,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M345.7,122.114v28.9a3.452,3.452,0,1,0,6.9,0v-28.9a22.389,22.389,0,1,1,44.779,0v28.9a3.452,3.452,0,1,0,6.9,0v-28.9a29.293,29.293,0,1,0-58.586,0",
    transform: "translate(-345.697 -92.82)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.223,
    y1: 3.718,
    x2: -2.216,
    y2: 3.718,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M360.839,391.622a5.875,5.875,0,1,0,5.876-5.875,5.876,5.876,0,0,0-5.876,5.875",
    transform: "translate(-360.839 -385.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -11.567,
    y1: 10.117,
    x2: -11.535,
    y2: 10.117,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M458.272,391.622a5.875,5.875,0,1,0,5.875-5.875,5.875,5.875,0,0,0-5.875,5.875",
    transform: "translate(-458.272 -385.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -14.69,
    y1: 10.117,
    x2: -14.658,
    y2: 10.117,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M363.586,518.69a3.568,3.568,0,1,0,7.135,0c0-4.2,7.036-8.872,17.132-8.872s17.134,4.674,17.134,8.872a3.568,3.568,0,1,0,7.135,0c0-8.978-10.66-16.01-24.269-16.01s-24.268,7.031-24.268,16.01",
    transform: "translate(-363.586 -502.68)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -2.822,
    y1: 3.822,
    x2: -2.814,
    y2: 3.822,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7e4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7d0d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3592",
    "data-name": "Group 3592",
    transform: "translate(0 64.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3591",
    "data-name": "Group 3591",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1100",
    "data-name": "Rectangle 1100",
    width: 295.343,
    height: 197.194,
    transform: "translate(0 -42.026)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3594",
    "data-name": "Group 3594",
    transform: "translate(53.803 43.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3593",
    "data-name": "Group 3593",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 147.462,
    height: 175.984,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596",
    transform: "translate(65.048 43.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3595",
    "data-name": "Group 3595",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 39.307,
    height: 26.687,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598",
    transform: "translate(78.124 43.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 26.231,
    height: 170.422,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600",
    transform: "translate(106.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3599",
    "data-name": "Group 3599",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 32.745,
    height: 61.644,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602",
    transform: "translate(89.054 43.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 148.173,
    height: 175.984,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3604",
    "data-name": "Group 3604",
    transform: "translate(178.497 51.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 13.71,
    height: 13.709,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3606",
    "data-name": "Group 3606",
    transform: "translate(126.814 51.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 13.709,
    height: 13.709,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3608",
    "data-name": "Group 3608",
    transform: "translate(130.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 58.586,
    height: 61.644,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3610",
    "data-name": "Group 3610",
    transform: "translate(135.921 110.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3609",
    "data-name": "Group 3609",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 11.751,
    height: 11.751,
    fill: "url(#linear-gradient-10)"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3612",
    "data-name": "Group 3612",
    transform: "translate(172.622 110.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3611",
    "data-name": "Group 3611",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    "data-name": "Rectangle 1110",
    width: 11.751,
    height: 11.751,
    fill: "url(#linear-gradient-11)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3614",
    "data-name": "Group 3614",
    transform: "translate(136.956 154.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3613",
    "data-name": "Group 3613",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 48.536,
    height: 19.578,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.ea6fa70eca258060b7a0bef2fc8ef910.svg";
export { ForwardRef as ReactComponent };